import {
  Info as InfoIcon,
  Settings as SettingsIcon,
  Chat as ChatIcon,
  RecordVoiceOver as VoiceIcon,
  HelpOutline as HelpIcon,
  MonetizationOn as PricingIcon,
  Textsms as PromptIcon,
  Tune as CustomizeIcon,
} from "@mui/icons-material";
import { NavigationItem, NavigationSingleItem, NavigationGroupItem } from "../NavigationList";

const createNavigationSingleItem = (item: NavigationSingleItem) => item;
const createNavigationGroupItem = (item: NavigationGroupItem) => item;

export const NAVIGATION_ITEMS: NavigationItem[] = [
  createNavigationSingleItem({
    icon: InfoIcon,
    title: '初めての方へ',
    href: "/info#ai-line-bot",
  }),

  createNavigationSingleItem({
    icon: SettingsIcon,
    title: '基本設定',
    href: "/linebots",
  }),
  createNavigationSingleItem({
    icon: PromptIcon,
    title: '受け答え設定',
    href: "/prompts",
  }),
  createNavigationSingleItem({
    icon: VoiceIcon,
    title: 'Demo音声AI',
    href: "/infospeech",
  }),
  createNavigationSingleItem({
    icon: HelpIcon,
    title: '操作方法',
    href: "/guide",
  }),
  createNavigationSingleItem({
    icon: PricingIcon,
    title: '料金プラン',
    href: "/info#pricing",
  }),  
];
